import React, { useEffect, useState } from "react";
import TronWeb from "tronweb";
import CountdownTimer from "../../container/CountdownTimer/CountdownTimer";
import {
  DepositContainer,
  DepositCopyButton,
  DepositLinkBox,
  DepositPaidButton,
} from "./Deposit.styled";
import { useDispatch, useSelector } from "react-redux";
import {
  getDeposit,
  updateDeposit,
} from "../../feature/deposit/DepositActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactLoading from "react-loading";
import { clearMessage } from "../../feature/message/messageSlice";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import SuccessPage from "../SuccessPage/SuccessPage";

const Deposit = () => {
  const param = useParams();
  const [timeLeft, setTimeLeft] = useState(0);
  const [depositSuccess, setDepositSuccess] = useState(0);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);
  const { deposit } = useSelector((state) => state.deposit);

  const address_used = deposit && deposit.address_used;

  const NODE = process.env.REACT_APP_TRON_NODE;
  const EVENT_SERVER = process.env.REACT_APP_EVENT_SERVER;

  useEffect(() => {
    // Convert the Django date string to a JavaScript Date object
    const dateObj = new Date(deposit.date);
    // Calculate the current date and time
    const currentDate = new Date();
    // Add one hour to the current date
    const oneHourLater = new Date(currentDate.getTime() + 1 * 60 * 60 * 1000);
    if (
      dateObj > oneHourLater ||
      deposit.status === "SUCCESS" ||
      (Object.keys(user).length && deposit.user !== user.id)
    ) {
      localStorage.removeItem("endTime");
      localStorage.removeItem("depositId");
      navigate("/balance");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deposit, navigate]);

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(clearInputError());
  }, [dispatch]);

  useEffect(() => {
    Object.keys(user).length && dispatch(getDeposit({ id: param.id }));
  }, [dispatch, param.id, user]);

  useEffect(() => {
    // Get the stored endTime value from localStorage, or set a new value if it doesn't exist
    let storedEndTime = localStorage.getItem("endTime") || setNewEndTime();

    // Start the timer with the remaining time
    const timer = setInterval(async () => {
      const timeLeft = storedEndTime - Date.now();

      if (timeLeft <= 0) {
        // If the timer has expired, clear the interval and update the endTime value
        clearInterval(timer);
        storedEndTime = setNewEndTime();
        setTimeLeft(0);

        localStorage.removeItem("endTime");
        localStorage.removeItem("depositId");
        navigate("/balance");

        // Check if the stored endTime value has expired
        if (storedEndTime < Date.now()) {
          // If it has expired, set a new value for endTime
          storedEndTime = setNewEndTime();
        }
      } else {
        setTimeLeft(timeLeft);
      }
    }, 1000);

    // Return a cleanup function to clear the interval when the component unmounts
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setNewEndTime = () => {
    const endTime = Date.now() + 3600000; // End time is one hour from now (3600000)
    localStorage.setItem("endTime", endTime);
    return endTime;
  };

  return (
    <>
      {depositSuccess ? (
        <SuccessPage
          message="Deposit Successful"
          links={[{ link: "/balance", name: "Balance" }]}
        />
      ) : (
        <DepositContainer>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "10px",
              backgroundColor: "#7B36EE",
              color: "#fff",
              padding: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
            }}
          >
            SCAN THE QR CODE BELOW OR COPY THE PAYMENT ADDRESS
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
              marginBlock: "0px",
            }}
          >
            <h4 style={{ margin: "0px" }}>
              Remaining Time: <CountdownTimer timeLeft={timeLeft} />
            </h4>
            <div style={{ fontSize: "10px" }}>
              <p style={{ textAlign: "center" }}>
                Kindly make use of this address to complete your payment within
                the allocated timeframe. It is important not to save this
                address for future transactions as it will become invalid after
                the specified timeframe has elapsed. In the event that you are
                unable to deposit within the specified timeframe, a new address
                can be generated
              </p>
              <p style={{ textAlign: "center", color: "#C597F8" }}>
                This payment is only supported on the TRX (TRC20) network.
                Payment(s) sent to any other network/chain will not be processed
                and your funds will be unrecoverable
              </p>
              <p style={{ textAlign: "center" }}>
                Copy or scan deposit address below and after deposit, click on
                “I HAVE DEPOSITED”
              </p>
            </div>
            {timeLeft !== 0 ? (
              <img
                style={{
                  height: "160px",
                  width: "160px",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                }}
                src={`https://chart.googleapis.com/chart?chs=500x500&cht=qr&chl=${address_used}&choe=UTF-8`}
                alt="qr"
              />
            ) : (
              <div
                style={{
                  height: "160px",
                  width: "160px",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                }}
              ></div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <DepositLinkBox style={{ fontSize: "15px" }}>
                {timeLeft !== 0 ? address_used : ""}
              </DepositLinkBox>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <DepositCopyButton
              onClick={() => {
                navigator.clipboard
                  .writeText(timeLeft !== 0 ? address_used : "")
                  .then(() => {
                    alert("Deposit address copied to clipboard");
                  })
                  .catch(console.error);
              }}
            >
              Copy address
            </DepositCopyButton>
            <DepositPaidButton
              onClick={async () => {
                setLoading(true);
                const tronWeb = new TronWeb({
                  fullNode: NODE,
                  solidityNode: NODE,
                  eventServer: EVENT_SERVER,
                });

                const balance = await tronWeb.trx.getBalance(address_used);
                if (balance > 0) {
                  dispatch(
                    updateDeposit({
                      user: user.id,
                      id: param.id,
                    })
                  )
                    .unwrap()
                    .then((res) => {
                      localStorage.removeItem("endTime");
                      setDepositSuccess(true);
                      setLoading(false);
                    })
                    .catch((error) => {
                      localStorage.removeItem("endTime");
                      setLoading(false);
                      alert("Something went wrong, please contact admin.");
                      navigate("/balance");
                    });
                  // inputError !== undefined && alert(inputError);
                } else {
                  setLoading(false);
                  alert("No funds in the wallet yet!");
                }
              }}
              disabled={loading}
            >
              {loading ? (
                <ReactLoading
                  type={"spinningBubbles"}
                  height={"20px"}
                  width={"20px"}
                />
              ) : (
                "I have deposited"
              )}
            </DepositPaidButton>
          </div>
        </DepositContainer>
      )}
    </>
  );
};

export default Deposit;
